module.exports = __webpack_public_path__ + "img/img_tskbg3@2x.754a6f0f.png";